import ApiService from './api'

export default {
  getStreams() {
    return ApiService.get('/streams')
  },
}
